import type {
  AlinhamentoBlocoSentenca,
  MarcaTrechoSentenca,
  TrechoSentenca,
} from '../types/sentencaArbitral.types';

const CLASSE_DO_ALINHAMENTO: Readonly<Record<AlinhamentoBlocoSentenca, string>> = {
  esquerda: 'text-left',
  centro: 'text-center',
  direita: 'text-right',
  justificado: 'text-justify',
};

/**
 * Marcas do trecho. Sentença v1 não tem `marcas`: o `estilo` dela comporta uma só e é a fonte.
 * Par do `marcasDoTrecho` de `sentencaPdfCorpo.ts` no core — tela e PDF leem igual.
 *
 * @example marcasDoTrecho({ texto: 'a', estilo: 'enfase' }) // ['negrito']
 */
export function marcasDoTrecho(trecho: TrechoSentenca): readonly MarcaTrechoSentenca[] {
  if (trecho.marcas) return trecho.marcas;
  if (trecho.estilo === 'enfase') return ['negrito'];
  if (trecho.estilo === 'italico') return ['italico'];
  return [];
}

/**
 * Classe Tailwind do alinhamento do bloco. Sem alinhamento (sentença v1) vale o justificado com
 * que ela foi publicada.
 *
 * @example classeDoAlinhamento('direita') // 'text-right'
 */
export function classeDoAlinhamento(alinhamento: AlinhamentoBlocoSentenca | undefined): string {
  return alinhamento ? CLASSE_DO_ALINHAMENTO[alinhamento] : 'text-justify';
}
